module.exports = __webpack_public_path__ + "images/accents/accent-box-quizmaker-c2005748ef2c9737b000bdbce2ea7d51.webp";